<template>
  <!-- 我的收藏 -->
  <div class="purse-body">
    <!-- 标题 -->
    <p class="title-Individual-center">
      个人中心 <i class="el-icon-arrow-right"></i>
      <span
        class="span-Individual-center firm-clickable"
        :style="reveal == '2' ? 'color:#333333' : ''"
        @click="handelBack"
        >邀请</span
      >&nbsp;<i v-if="reveal == '2'" class="el-icon-arrow-right firm-clickable"></i>&nbsp;<span
        v-if="reveal == '2'"
        style="color: #409eff "
        >{{ InviteName }}</span
      ><span v-if="reveal == '2'" class="span-Individual-center firm-clickable"
        >(充值消费详情)</span
      >
    </p>
    <!-- 内容主体 -->
    <div class="Content-subject">
      <!-- 筛选区 -->
      <div class="searchRegion">
        <p>时间：</p>
        <!-- 时间选择 -->
        <el-date-picker
          v-model="value1"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          unlink-panels
          clearable
          @clear="value1 = null"
        >
        </el-date-picker>
        <p class="user-Id" v-if="reveal == '1'">用户ID：</p>
        <p class="user-Id" v-else>订单号：</p>
        <!-- 用户id输入 -->
        <div class="size-search" v-if="reveal == '1'">
          <el-input v-model="input" placeholder="请输入用户ID"></el-input>
        </div>
        <div class="size-search" v-else>
          <el-input v-model="input1" placeholder="请输入订单ID"></el-input>
        </div>
        <!-- 按钮 -->
        <p class="ser-btn public-style" @click="handelSearch">搜 索</p>
        <p class="heavy-btn public-style" @click="handelReset">重 置</p>
        <div class="Back" v-if="reveal == '2'" @click="handelBack"></div>
      </div>
      <!-- 切换 -->
      <div class="Toggle">
        <div class="Toggle-body" v-if="reveal == '1'">
          <p
            v-for="(item, index) in selectArr"
            :key="index"
            :class="select == item.id ? 'select-p' : ''"
            @click="handelSelect(item.id)"
          >
            {{ item.name }}({{ item.quantity }})
          </p>
        </div>
        <div class="Toggle-body" v-if="reveal == '2'">
          <div class="Toggle-avatar">
            <img src="../../../../../assets/imgs/tx1@3x.svg" alt="" />
          </div>
          <div class="Toggle-details">
            <div>{{ InviteName }}</div>
            <div>充值/消费记录</div>
          </div>
        </div>

        <div class="Toggle-received">
          <div class="received">
            <div class="received-body">
              <div class="img-icon"></div>
              已获侦迹币<span>{{ obtained }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 内容 -->
      <div class="collected">
        <tableInvite
          v-if="reveal == '1'"
          :tableData="tableData"
          :select="select"
          @handelClickName="handelClickName"
        ></tableInvite>
        <detailsTable
          v-if="reveal == '2'"
          :tableData="DetailsData"
          @handelClickName="handelClickName"
        ></detailsTable>
      </div>
      <!-- 底部分页 -->
      <div class="paging-box">
        <div class="paging" v-if="reveal == '1'">
          <paging
            :pagingObj="pagingObj"
            @handleCurrentChange="handleCurrentChange"
          ></paging>
        </div>
        <div class="paging" v-else>
          <paging
            :pagingObj="conPagingObj"
            @handleCurrentChange="handleCurrentChange"
          ></paging>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入接口
import {
  getKickbackTraceCoin, // 获得侦迹币数量
  postGetMyInviteRecords, // 邀请列表
  postGetBeInviteRechargeRecords, // 我邀请的人/企业充值记录查询
  postGetMyInviteRecordCount, //我的邀请 企业()  个人（） 数量接口
} from "../../../../../assets/api/index";
// 引入分页组件
import paging from "../../../../../components/paging.vue";
// 引入会员信息表格
import tableInvite from "./components/tableInvite.vue";
// 引入 提成表格
import detailsTable from "./components/detailsTable.vue";
export default {
  data() {
    return {
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 邀请列表分页数据
      conPagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 邀请人消费列表分页数据
      value1: null, // 时间搜索
      input: "", // 用户id搜索
      input1: "", // 定单编号
      selectArr: [
        { name: "会员信息", quantity: "", id: "-1" },
        { name: "个人", quantity: "", id: "0" },
        { name: "企业", quantity: "", id: "1" },
      ], // 切换 数据列表
      // quantity:{}, // 展示企业   个人 条数
      select: "-1", // 筛选
      tableData: [], //表格数据
      DetailsData: [], // 提成详情数据
      reveal: "1", // 进入到提成页面出现x点击返回
      InviteName: "", // 邀请的人\
      obtained: "", // 已获得侦迹币总数
      BeInvitedId: "", // 被邀请人id用于调用被邀请人充值记录详情列表
      Type: "", // 被邀请的是人/企业 0 / 1
    };
  },
  watch: {

  },
  components: {
    paging,
    tableInvite,
    detailsTable,
  },
  created() {
    this.getKickbackTraceCoin(); // 获得的侦迹币数量
    this.postGetMyInviteRecords(); // 邀请列表
    this.postGetMyInviteRecordCount(); // 切换菜单（）内的数量
  },
  methods: {
    // 我的邀请 ----------------------- 企业  个人  数量 ------------------------------
    async postGetMyInviteRecordCount() {
      var data = {};
      data.data = {
        inviteId: this.$store.getters.getUser.id,
      };
      const res = await postGetMyInviteRecordCount(data, 1, 10);
      // 循环把总条数放入 数组selectArr
      for (var i in this.selectArr) {
        if (this.selectArr[i].id == "-1") {
          this.selectArr[i].quantity = res.data.total;
        } else if (this.selectArr[i].id == "0") {
          this.selectArr[i].quantity = res.data.personCount;
        } else {
          this.selectArr[i].quantity = res.data.companyCount;
        }
      }
    },
    // 我的邀请 ------------------------- 查询我邀请的 个人/企业 充值记录 ------------------------
    async postGetBeInviteRechargeRecords() {
      var data = {};
      // 处理时间
      var time;
      var timeEnd;
      var range = this.value1;
      if (Array.isArray(range) && range.length === 2 && range[0] && range[1]) {
        time = range[0] + " " + "00:00:00";
        timeEnd = range[1] + " " + "23:59:59";
      }
      data.data = {
        targetId: this.BeInvitedId, // 被邀请人 id
        orderNumber: this.input1, // 搜索-订单ID
        beInvitedType: this.Type, // 类型
        startTime: time, // 搜索/筛选传的 开始时间
        endTime: timeEnd, // 搜索/筛选传的 结束时间
      };
      const res = await postGetBeInviteRechargeRecords(
        data,
        this.conPagingObj.currentPage,
        this.conPagingObj.pageSize
      );
      // 接口请求成功
      if (res.code == 0) {
        // list 数据总数
        this.pagingObj.totalDevice = res.data.total;
        // 我的邀请 表格数据、
        this.DetailsData = res.data.list;
      } else {
        // 接口请求失败
        // this.$tool.PromptBox("error", res.msg);
      }
    },
    // 我的邀请------------------------------我的获得侦迹币总数- ---------------------------------
    async getKickbackTraceCoin(type, userId) {
      // 调用已获得侦迹币 接口
      var data = {
        data: {
          inviterId: this.$store.getters.getUser.id,
          inviterType: 0,
          beInvitedType: type, //被邀请类型
          beInvitedUserId: userId, //被邀请id
        },
      };
      const res = await getKickbackTraceCoin(data);
      // 总数赋值
      this.obtained = res.data;
    },
    // 我的邀请 ------------------------------------------ 邀请列表-------------------------------
    async postGetMyInviteRecords() {
      var data = {};
      // 处理时间
      var time;
      var timeEnd;
      var range = this.value1;
      if (Array.isArray(range) && range.length === 2 && range[0] && range[1]) {
        time = range[0] + " " + "00:00:00";
        timeEnd = range[1] + " " + "23:59:59";
      }
      data.data = {
        inviteId: this.$store.getters.getUser.id, // userid
        inviteType: 0,
        beInvitedType:
          this.select == "-1" ? "" : this.select == "0" ? "0" : "1", // 类型
        targetCode: this.input, // 目标 id
        startTime: time, // 搜索/筛选传的 开始时间
        endTime: timeEnd, // 搜索/筛选传的 结束时间
      };
      // 调用邀请列表接口
      const res = await postGetMyInviteRecords(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      );
      // 接口请求成功
      if (res.code == 0) {
        console.log(res, "res");
        // list 数据总数
        this.pagingObj.totalDevice = res.data.total;
        // 我的邀请 表格数据、
        this.tableData = res.data.list;
      }
    },
    //------------------------------------- 搜索按钮-----------------------------
    handelSearch() {
      // 1是搜索邀请列表数据   else搜索被邀请人消费记录详情
      if (this.reveal == "1") {
        this.pagingObj.currentPage = 1;
        this.postGetMyInviteRecords();
      } else {
        this.conPagingObj.currentPage = 1;
        this.postGetBeInviteRechargeRecords();
      }
    },
    // ----------------------------------------重置按钮--------------------------------
    handelReset() {
      this.value1 = null;
      this.input = "";
      this.input1 = "";
      // 1重置调用 我的邀请列表    else重置调用 我邀请的用户详情列表
      if (this.reveal == "1") {
        this.pagingObj.currentPage = 1;
        this.postGetMyInviteRecords();
      } else {
        this.conPagingObj.currentPage = 1;
        this.postGetBeInviteRechargeRecords();
      }
    },
    // ---------------------------------------点击查看提成详情-----------------------------
    handelClickName(val) {
      console.log(val, "val");
      this.BeInvitedId = val.beInvitedUserId;
      this.Type = val.beInvitedType;
      this.postGetBeInviteRechargeRecords();
      // 获取侦迹币数量
      this.getKickbackTraceCoin(val.beInvitedType, val.beInvitedUserId);
      // 获取点击的数据会员名称
      this.InviteName = val.beInvitedUserCode;
      // 显示返回按钮
      this.reveal = "2";
    },
    // 返回到正常表格
    handelBack() {
      // 获取侦迹币总数
      this.getKickbackTraceCoin(this.$store.getters.getUser.id);
      this.reveal = "1";
    },
    // 分页
    handleCurrentChange(val) {
      // 邀请列表分页
      if (reveal == "1") {
        this.pagingObj.currentPage = val;
        this.postGetMyInviteRecords();
      } else {
        //被邀请人消费详情列表分页
        this.conPagingObj.currentPage = val;
        this.postGetBeInviteRechargeRecords();
      }
    },
    //筛选 会员信息 个人 企业
    handelSelect(num) {
      this.pagingObj.currentPage = 1;
      this.select = num;
      this.postGetMyInviteRecords();
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-date-editor {
  box-sizing: border-box !important;
  border: 1px solid #409eff ;
  height: 35px;
  width: 240px;
  line-height: 35px !important;
  padding: 0 8px !important;
}
/deep/.el-icon-date {
  font-size: 18px !important;
  margin-left: 0 !important;
}
/deep/.el-range__close-icon {
  line-height: 35px;
  width: 25px;
}

.purse-body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  // 内容主体
  .Content-subject {
    width: 100%;
    min-height: 540px;
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
    border-radius: 5px;
    margin-top: 13px;
    padding: 30px;

    // 搜索区域
    .searchRegion {
      width: 100%;
      height: 35px;
      line-height: 35px;
      display: flex;
      font-family: PingFangSC-Medium;
      font-size: 12px;
      color: #333333;
      font-weight: 400;
      display: flex;
      position: relative;
      .Back {
        width: 20px;
        height: 20px;
        // border: 1px solid gold;
        position: absolute;
        right: 0px;
        top: 10px;
        background-image: url("../../../../../assets/imgs/back-da@3x.svg");
        background-size: 100% 100%;
      }
      .user-Id {
        margin-left: 30px;
      }
      .public-style {
        width: 75px;
        height: 35px;
        text-align: center;
        border-radius: 5px;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        font-weight: 400;
        box-sizing: border-box;
        border: 1px solid #409eff ;
        cursor: pointer;
      }
      .ser-btn {
        background: #409eff ;
        color: #ffffff;
        margin-left: 30px;
        margin-right: 10px;
      }
      .heavy-btn {
        background: #ffffff;
        color: #409eff ;
      }
      .size-search {
        width: 200px;
        height: 30px;
        font-size: 14px;
        /deep/.el-input__inner {
          height: 35px !important;
          border: 1px solid #409eff ;
        }
      }
    }
    // 切换导航
    .Toggle {
      width: 100%;
      height: 35px;
      line-height: 35px;
      margin-top: 30px;
      display: flex;
      color: #333333;
      text-align: center;
      font-weight: 400;
      .Toggle-body {
        flex: 1;
        display: flex;
        font-size: 16px;
        p {
          margin-right: 30px;
          cursor: pointer;
        }
        .select-p {
          color: #409eff ;
          box-sizing: border-box;
          border-bottom: 2px solid #409eff ;
        }
        .Toggle-avatar {
          width: 40px;
          height: 40px;
          margin-right: 10px;
          border-radius: 50%;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .Toggle-details {
          div {
            height: 22px;
            line-height: 22px;
            text-align: left;
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: #333333;
            font-weight: 400;
          }
        }
      }
      // 已得
      .Toggle-received {
        width: 350px;
        display: flex;
        justify-content: flex-end;
        .received {
          width: 160px;
          height: 35px;
          border: 1px solid #409eff ;
          border-radius: 5px;
          display: flex;
          .received-body {
            width: 140px;
            height: 20px;
            line-height: 20px;
            margin: auto;
            display: flex;
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color: #409eff ;
            font-weight: 400;
            span {
              font-size: 16px;
              color: #fe574a;
              font-weight: 400;
              margin-left: 5px;
            }
            .img-icon {
              width: 20px;
              height: 20px;
              margin-right: 5px;
              background-image: url("../../../../../assets/imgs/qianbao@3x.svg");
              background-size: 100% 100%;
            }
          }
        }
      }
    }
    //
    .collected {
      width: 100%;
      min-height: 400px;
      box-sizing: border-box;
      margin-top: 30px;
    }
    // 分页
    .paging-box {
      width: 100%;
      height: 22px;
      margin-top: 30px;
      display: flex;
      justify-content: flex-end;
      .paging {
        width: 90%;
        height: 100%;
        display: flex;
        justify-content: flex-end;
      }
    }
  }
}
</style>
